import { AuthService } from 'src/app/air/modules/common/service/auth/auth.service';
import { AirAppRoutes } from 'src/app/air/modules/common/lib/air-api-constant';
import { CommonService } from 'src/app/air/modules/common/service/common/common.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StorageService } from '../../../service/storage/storage.service';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
    private errorCount: number = 0;
    constructor(
        private commonService: CommonService,
        private authService: AuthService,
        private storageService: StorageService
    ) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                    }
                },
                /* For checking important APIs which if fails the application will redirect to Maintenance Page*/
                // (err: HttpErrorResponse) => {
                //     if (err.url)
                //         // if (
                //         //     err.url.includes('getConfig') ||
                //         //     err.url.includes('company') ||
                //         //     err.url.includes('shipmentResult') ||
                //         //     err.url.includes('shipmentTypeIndicators') ||
                //         //     err.url.includes('shipmentTypeIndicators')
                //         // ) {
                //         //     this.authService.updateEula(true);
                //         //     this.commonService.navigateRoute({
                //         //         route: AirAppRoutes.User.MAINTENANCE,
                //         //         type: 'User',
                //         //     });
                //         //     this.storageService.setItem('errorCount', 1);
                //         // }
                //     /* For counting the number of errors for the all the APIs , Currently disabled as it might not be used
                //      */
                //     // if (this.errorCount >= 15) {
                //     //   this.authService.updateEula(true);
                //     //   this.commonService.navigateRoute({
                //     //     route: AirAppRoutes.User.MAINTENANCE,
                //     //     type: 'User',
                //     //   })
                //     //   this.errorCount = 0;
                //     // }
                // }
            )
        );
    }
}
